import { makeStyles, Theme, createStyles, ClickAwayListener, PopperProps, Popper, ClickAwayListenerProps } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { observer } from "mobx-react";
import { DialogState } from "../../../../stores/models/DialogState";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popper: {
            zIndex: theme.zIndex.modal
        },
        container: {
            background: 'white',
            borderRadius: theme.shape.borderRadius
        },
        nestedMenu: {
            marginLeft: '3px',
            marginRight: '3px'
        }
    })
);

export interface ClickAwayPopperProps extends Omit<ClickAwayListenerProps, 'onClickAway'> {
    state: DialogState;
    anchorEl?: React.RefObject<any>;
    PopperProps?: Partial<PopperProps>;
    nested?: boolean;
}

const ClickAwayPopper: FunctionComponent<ClickAwayPopperProps> = observer((props) => {

    const classes = useStyles();

    /********* Event handler *********/

    const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
        if (props.anchorEl?.current.contains(event.target as Node)) {
            return;
        }

        props.state.setOpen(false);
    };

    /********* Render *********/

    return (
        <Popper
            {...props.PopperProps}
            disablePortal={false}
            open={props.state.open}
            anchorEl={props.anchorEl?.current}
            className={clsx(props.PopperProps ? props.PopperProps.className : undefined, props.nested ? classes.nestedMenu : undefined, classes.popper)}
            modifiers={[
                {
                    flip: { enabled: true },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'viewport'
                    }
                },
            ]}
        >
            <ClickAwayListener onClickAway={handleClose}>
                <div className={props.nested ? classes.container : undefined}>
                    {props.children}
                </div>
            </ClickAwayListener>
        </Popper>
    );
});

export default ClickAwayPopper;